import { Button, Text } from '@mantine/core';
import { useTheme } from 'styled-components';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import { HeaderContainer } from './SignerSigningHeader.styled';

interface Props {
	signerDisplayName: string;
	canGoBack: boolean;
	onBack: () => void;
}

export const SignerSigningHeader = ({ signerDisplayName, canGoBack, onBack }: Props) => {
	const theme = useTheme();

	return (
		<HeaderContainer>
			{canGoBack ? (
				<Button
					variant="subtle"
					leftSection={<Icon variant="arrow-left-v3" />}
					onClick={onBack}
					sx={{
						color: theme.v2.color.neutral[1100],
						fontWeight: 600,
						'&:hover': {
							background: 'transparent',
							color: theme.v2.color.secondary[1000],
						},
					}}
				>
					{signerDisplayName}
				</Button>
			) : (
				<Text fw={600} px="0.75rem" py="0.5rem" c={theme.v2.color.neutral[1100]}>
					{signerDisplayName}
				</Text>
			)}
		</HeaderContainer>
	);
};
